import { createSelector } from 'reselect';

import { IServices } from '@r1-frontend/api-domru/api-profile/v2/info/all/dto/ResponseDto';

import { PRODUCTS } from '~/src/constants';
import { TState } from '~/src/store';
import { IClientPersonal } from '~/src/store/reducers/auth';

export const selectClientServices = (state: TState): IServices[] | null => {
    return state.auth.clientProducts?.services || null;
};

/**
 * Получить agreementId
 *
 * @function
 * @name store.selectors.service.selectClientAgreementId
 * @param {object} state - Состояние
 * @returns {number}
 */
export const selectClientAgreementId = (state: TState): IClientPersonal['agreementId'] | null => {
    return state.auth.clientPersonal?.agreementId || null;
};

export const selectActiveServicesIds = createSelector(
    selectClientServices,
    (items) => {
        if (items == null) {
            return [];
        }
        return items
            .reduce((acc, val) => {
                if (val.activated === 1) {
                    acc.push(val.productId);
                }
                return acc;
            }, <number[]>[]);
    },
);

export const selectNotSuspendServicesIds = createSelector(
    selectClientServices,
    (items) => {
        if (!items) {
            return [];
        }
        return items
            .reduce((acc, val) => {
                if (val.suspendStatus === 0) {
                    acc.push(val.productId);
                }
                return acc;
            }, <number[]>[]);
    },
);

export const selectInternetService = createSelector(
    selectClientServices,
    (items: IServices[] | null) => items ? items.find((item) => item.productId === PRODUCTS.internet) : null,
);

export const selectTerminalResource = function(state: TState): number | null {
    const internetServiceItem = selectInternetService(state);
    if (!internetServiceItem) {
        return null;
    }
    return internetServiceItem.terminalResources[0].id;
};
